import { z } from "zod/v4";
import { SalifyRegex } from "..";

export enum ValidationType {
  email = "Email",
  phone = "Phone",
}

function buildValidator({
  zodType,
  required,
  requiredMessage = "Trường bắt buộc",
  rules = [],
}: {
  zodType: "string" | "number";
  required: boolean;
  requiredMessage: string | undefined;
  rules: any[];
}) {
  switch (zodType) {
    case "string":
      let validator = z.string(
        required
          ? {
              error: requiredMessage,
            }
          : undefined,
      );
      if (required) {
        rules.unshift(z.minLength(1, { error: requiredMessage }));
        return validator.check(...rules);
      } else {
        return z
          .string()
          .check(...rules)
          .optional();
      }

    default:
      throw `Chưa xử lý validate với zod type: ${zodType}`;
  }
}

export class SalifyFormValidator {
  static dynamicFormValidator({
    required,
    type,
    requiredMessage,
  }: {
    required: boolean;
    type: ValidationType | undefined;
    requiredMessage?: string;
  }) {
    switch (type) {
      case ValidationType.phone:
        return buildValidator({
          zodType: "string",
          required: required,
          requiredMessage: requiredMessage,
          rules: [
            z.regex(SalifyRegex.phoneNumber, {
              error: "Số điện thoại không hợp lệ",
            }),
          ],
        });

      case ValidationType.email:
        return buildValidator({
          zodType: "string",
          required: required,
          requiredMessage: requiredMessage,
          rules: [z.email({ error: "Địa chỉ Email không hợp lệ" })],
        });

      default:
        return buildValidator({
          zodType: "string",
          required: required,
          requiredMessage: requiredMessage,
          rules: [],
        });
    }
  }
}
